import { call, put, select } from 'redux-saga/effects';

import { sendToLogger } from 'connect/saga/helpers';
import { selectDataUser } from 'connect/selectors';

import { RequestOffer } from '../offer/request-offer';
import { SagaHandler } from '../SagaHandler';

import { Signup } from './signup';

class _SignupWithOffer extends SagaHandler {
  constructor() {
    super({
      actionName: 'data/SIGNUP_WITH_OFFER',
      stateKey: 'signupWithOffer',
      category: 'data',
    });
  }

  /**
   * @param {object} params
   * @param {object} params.userData
   * @param {string} params.userData.email
   * @param {string | null} [params.userData.mobilePhone]
   * @param {string} params.userData.patientSignupSource
   * @param {string} params.offerCode
   * @param {object} [params.match]
   * @param {string} [params.matchToken]
   */
  createAction({ userData, match, matchToken, offerCode }) {
    return {
      type: this._actionName,
      userData,
      match,
      matchToken,
      offerCode,
    };
  }

  *saga({ userData, match, matchToken, offerCode }) {
    const { loading: loadingHandler, error: errorHandler } = this;

    try {
      yield put(loadingHandler.update(true));
      yield put(errorHandler.update(null));

      const user = yield select(selectDataUser);
      const isUserAuthenticated = Boolean(user?.authenticated);

      // Skip signup if user is already authenticated
      if (!isUserAuthenticated) {
        yield call(Signup.saga, { userData, match, matchToken });
        const signupError = yield select(Signup.error.selector);
        if (signupError) {
          yield put(errorHandler.update(signupError));
          return;
        }
      }

      yield call(RequestOffer.saga, { payload: offerCode });
      const requestOfferError = yield select(RequestOffer.error.selector);
      if (requestOfferError) {
        yield put(errorHandler.update(requestOfferError));
        return;
      }
    } catch (error) {
      sendToLogger(error, 'signupUserAndApplyOffer');
      yield put(errorHandler.update(error));
    } finally {
      yield put(loadingHandler.update(false));
    }
  }
}

export const SignupWithOffer = new _SignupWithOffer();
